import { ClinicalRelationships } from '../../../../../../constants';

export const PARENT_GUARDIAN_CLINICAL_RELATIONSHIPS = [
  ClinicalRelationships.Parent,
  ClinicalRelationships.PracticingGuardian,
] as const;
